var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":`${_vm.iconSize}px`,"height":`${_vm.iconSize}px`,"viewBox":"0 0 24 24","fill":_vm.fill},on:{"click":_vm.onClick}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_c('path',{attrs:{"d":"M3 18h6v-2H3v2zM3 6v2h18V6H3zm0 7h12v-2H3v2z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }